import {
  CarregarPermissoes,
  ValidarPermissao,
} from '@/modules/system/auth/application/auth.service';
import { NavigationView } from '@/shared/constants/navigation-view.enum';
import { isVisaoAdministrador } from '@/shared/constants/visao-sistema.constants';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import type { RoleLevelDto } from '@/modules/system/auth/domain/role-level.dto';

/** Suporte administrativo ao módulo de relatórios (visão Administrador ou ADMIN_ACTIONS). */
export function usuarioTemSuporteAdministrativoRelatorios(
  authVisao: NavigationView | null | undefined,
  permissoes: RoleLevelDto[] = CarregarPermissoes(),
): boolean {
  if (isVisaoAdministrador(authVisao)) return true;
  return ValidarPermissao(permissoes, [
    { role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ },
  ]);
}

/** Visões que consultam relatórios de qualquer defensor (sem serem o próprio defensor). */
const VISOES_CONSULTA_RELATORIOS_DE_DEFENSORES: readonly NavigationView[] = [
  NavigationView.Administrador,
  NavigationView.Corregedoria,
  NavigationView.RecursosHumanos,
  NavigationView.GestorRelatorios,
];

/**
 * Usuário sem perfil de defensor que pode consultar a lista de relatórios escolhendo o defensor
 * (Administrador, Corregedoria, Recursos Humanos, Gestor de Relatórios ou suporte administrativo).
 */
export function usuarioPodeConsultarRelatoriosDeQualquerDefensor(
  authVisao: NavigationView | null | undefined,
  permissoes: RoleLevelDto[] = CarregarPermissoes(),
): boolean {
  if (authVisao != null && VISOES_CONSULTA_RELATORIOS_DE_DEFENSORES.includes(authVisao)) {
    return true;
  }
  return usuarioTemSuporteAdministrativoRelatorios(authVisao, permissoes);
}
